
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import AuditReportListing from '../../modules/admin/components/AuditReport/AuditReportListing';

const AuditReport = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>AuditReport.AuditReport')} />
      <AuditReportListing/>
    </>
  );
}

export default AuditReport;